<template>
  <MyDialog :model-value="props.addressShow" @update:modelValue="$emit('close')" custom-class="z-[999] rounded-lg">
    <div class="w-full max-w-md bg-white rounded-lg border border-gray-200 overflow-y-auto relative py-[30px]"
      style="box-sizing: border-box">
      <button class="absolute top-2.5 right-2.5 mx-auto z-10 w-6 h-6 rounded hover:bg-black-1 bg-[#F3F4F9]"
        @click.stop="$emit('close')">
        <img class="m-auto" src="@assets/images/Icon_del.png" />
      </button>
      <div class="flex items-center justify-between mb-[30px] px-[30px]">
        <span class="text-sm font-semibold text-[#000] font-sans">选择地址</span>
      </div>
      <!-- <div class="text-xs text-[#737380] mb-[30px]">预计{{ getCurrentDeliveryTime() }}送达</div> -->
      <el-scrollbar :height="addressShowNums === 4 ? 'calc(4*85px)' : '505px'">
        <div class="flex flex-col gap-[10px] px-[30px]">
          <div v-for="(item, index) in props.addressList.slice(0, addressShowNums)" :key="item.id"
            @click="updateDefAddress(index)"
            class="flex flex-col items-start gap-[10px] w-full cursor-pointer transition-all duration-20" :class="addressId == item.id
              ? 'border-2 border-[#47496F] bg-[#F3F4F9] rounded-[8px] p-[10px_18px]'
              : 'border border-[#C9CAD6] bg-white rounded-[8px] p-[10px_20px]'
              ">
            <div class="flex items-top gap-[10px] w-full text-sm leading-4">
              <span :class="addressId == item.id ? 'text-[#000]' : 'text-[#737380]'"
                class="font-bold max-w-[51px] min-w-[51px] line-clamp-2">
                {{ item.name }}
              </span>
              <span class="text-[#737380] flex-1 line-clamp-2 break-all">
                {{ item.address }}
              </span>
            </div>
            <div class="flex text-[#737380] text-sm gap-[10px] leading-4">
              <div class="min-w-[51px] max-w-[51px] truncate">
                <AddressTagIcon :tagVal="item.tagVal" />
              </div>
              <div>{{ item.phone }}</div>
            </div>
          </div>
        </div>
      </el-scrollbar>

      <div class="flex gap-[10px] my-[30px] px-[30px]">
        <button
          class="flex-1 h-[26px] items-center justify-center rounded border border-[#C9CAD6] text-[#000] bg-white hover:bg-black-1 hover:text-white hover:border-black-1 text-sm transition-colors disabled:bg-[#F3F4F9] disabled:text-[#C9CAD6] disabled:border-[#C9CAD6]"
          :disabled="addressShowNums === props.addressList.length" @click="addressShowNums = props.addressList.length">
          全部展开
        </button>
        <router-link
          class="flex-1 h-[26px] rounded border border-[#47496F] text-white bg-[#47496F] text-sm flex items-center justify-center hover:bg-[#37395F] transition-colors"
          @click="$emit('close')" :to="{ name: 'Personal', query: { linkChild: 'address' } }">
          管理地址
        </router-link>
      </div>
      <div class="px-[30px] w-full">
        <button
          class="w-full h-10 rounded-md bg-[#47496F] text-white text-sm flex items-center justify-center hover:bg-[#37395F] transition-colors"
          @click="alterAddress">
          确认更改
        </button>
      </div>
    </div>
  </MyDialog>
</template>

<script setup>
import { ref, watch } from "vue";
import {
  calculateDeliveryTime,
  formatDeliveryDate,
} from "@/utils/deliveryTime";
import MyDialog from "@/components/MyDialog.vue";
import { ElMessage } from "element-plus";



import AddressTagIcon from "./AddressTagIcon.vue";

const props = defineProps({
  addressList: { type: Array, default: [] },
  addressShow: { type: Boolean, default: false },
  selectedAddress: { type: Object, default: {} },
  isConfirmOrder: { type: Boolean, default: false },
});

const emits = defineEmits(['addrChange']);

watch(props.selectedAddress, (val) => {
  addressId.value = val.id;
});
const addressId = ref(props.selectedAddress.id);
let addressShowNums = ref(4); // 显示地址条数配置

const selectedAddr = ref({});
selectedAddr.value = props.selectedAddress;

const currentSelectedAddress = ref(null);

function getCurrentDeliveryTime() {
  if (!currentSelectedAddress.value) {
    const defaultDelivery = calculateDeliveryTime();
    return formatDeliveryDate(defaultDelivery.estimatedDays);
  }
  const deliveryInfo = calculateDeliveryTime(currentSelectedAddress.value);
  return formatDeliveryDate(deliveryInfo.estimatedDays);
}

function updateDefAddress(index) {
  addressId.value = props.addressList[index].id;
  selectedAddr.value = props.addressList[index];
  currentSelectedAddress.value = props.addressList[index];
}

watch(
  () => props.selectedAddress,
  (newVal) => {
    if (newVal && newVal.id) {
      currentSelectedAddress.value = newVal;
    }
  },
  { immediate: true }
);

// 保证弹窗每次打开时高亮当前选中地址
watch(
  () => props.addressShow,
  (val) => {
    if (val && props.selectedAddress && props.selectedAddress.id) {
      addressId.value = props.selectedAddress.id;
    }
  },
  { immediate: true }
);

const alterAddress = () => {
  emits('addrChange', selectedAddr.value);
  if (props.isConfirmOrder) {
    ElMessage.success('地址更改成功');
  } else {
    ElMessage.success('默认地址更改成功');
  }
}
</script>

<style lang="sass" scoped></style>
